import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['positive', 'negative', 'save', 'saveConfirm']

  connect() {
    this.inputUnitsChanged({ target: this.element.querySelector('input[data-im-input]') })
    this.changeNoNoasChecked({ target: this.element.querySelector('input[data-no-noa]') })
  }

  inputUnitsChanged(event) {
    const value = parseInt(event.target.value) || 0
    this.positiveTarget.hidden = value <= 0
    this.negativeTarget.hidden = value >= 0
    this.uncheckAll()

    // autocheck if value is positive and we have a single noa
    const checkboxes = document.querySelectorAll('input[data-noa-checkbox-positive]')
    if (value >= 0 && checkboxes.length === 1) {
      checkboxes[0].checked = true
    }

    if (value === 1) {
      this.saveTarget.style.display = 'none'
      this.saveConfirmTarget.style.display = 'flex'
    } else {
      this.saveTarget.style.display = 'flex'
      this.saveConfirmTarget.style.display = 'none'
    }
  }

  changeNoNoasChecked(event) {
    const checkboxes = document.querySelectorAll('input[data-noa-checkbox]')
    checkboxes.forEach(checkbox => (checkbox.disabled = event.target.value > 0))
    this.uncheckAll()
  }

  uncheckAll() {
    const checkboxes = document.querySelectorAll('input[data-noa-checkbox]')
    checkboxes.forEach(checkbox => (checkbox.checked = false))
  }
}
